module.exports = __webpack_public_path__ + "img/Pag-IBIG.c1e20180.png";